<template>
  <div
    class="columns is-marginless infoBorderReseau"
    :class="{'selectt': infoReseauxPersonnalise.select}">
    <div class="column is-narrow is-paddingless position_relative">
      <img class="sizeImgReseau" :src="url">
      <div class="pointer level bgBlur">
        <div class="level-left"></div>
        <div
          class="level-right"
          v-if="getTarif">
          <p class="p_size18 has-text-weight-bold has-text-white goToLeft">
            {{formatNum(getTarif)}} HT
          </p>
        </div>
      </div>
    </div>
    <div class="column is-paddingless has-background-white">
      <div class="padding_medium">
        <p @click="show = true" class="pointer is-size-7 bottomViolet">
          <label class="has-text-default">Nom du réseau</label> <br>
          <strong class="p_size16 has-text-weight-bold has-text-link">
            {{infoReseauxPersonnalise.libelle}}
          </strong>
        </p>
        <div class="level bottomViolet">
          <div class="level-left is-marginless">
          </div>
          <div class="level-right">
          </div>
        </div>
        <div
          @click="show = true"
          class="pointer bottomViolet"
          v-if="infoReseauxPersonnalise.dateDebut"
        >
          <div class="media">
            <b-icon
              icon="timer"
              size="is-medium"
              class="media-left color-icon">
            </b-icon>
            <div class="media-content is-size-7">
              <label class="has-text-default">Période d'affichage :</label>
              <p class="p_size14 has-text-weight-bold has-text-link">
                {{'Du ' + infoReseauxPersonnalise.dateDebut +
                  ' au '+ infoReseauxPersonnalise.dateFin}}
              </p>
            </div>
          </div>
        </div>
        <div @click="show = true" class="pointer bottomViolet">
          <div class="media">
            <b-icon
              icon="sign-text"
              size="is-medium"
              class="media-left color-icon">
            </b-icon>
            <div class="media-content is-size-7">
              <label class="has-text-default">Nombre de faces </label><br>
              <p class="p_size14 has-text-link has-text-weight-bold">
                {{infoReseauxPersonnalise.nbFaces}}
              </p>
            </div>
          </div>
        </div>
        <div
            class="column is-12 is-paddingless bottomViolet"
            v-if="infoReseauxPersonnalise.commentaire">
            <div class="media">
              <div class="media-content is-size-7">
                <label class="has-text-weight-bold has-text-link p_size14">
                  Commentaire : </label><br>
                <p class="p_size12 has-text-default has-text-link">
                  {{infoReseauxPersonnalise.commentaire}}
                </p>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="column is-narrow">
      <div class="has-text-centered mb-btnaction">
        <div class="icon-forme pointer" :class="{'icon-select': infoReseauxPersonnalise.select}"
          @click="contolSelect()">
          <b-icon icon="cart"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px" v-if="!infoReseauxPersonnalise.select">
          Sélectionner</p>
        <p class="p_size10 has-text-default ml-5px" v-else>
          Retirer</p>
      </div>
      <div class="has-text-centered mb-btnaction">
        <div class="icon-forme topViolet pointer" @click="show = true">
          <b-icon icon="information"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px">
          Plus d'infos</p>
      </div>
      <div class="has-text-centered topViolet mb-btnaction">
        <app-export-excel
          :data="infoReseauxPersonnalise.faces"
          :nom="infoReseauxPersonnalise.libelle"
          :show-dimension="false"
          :periode="'Du ' + infoReseauxPersonnalise.dateDebut + ' au ' +
                    infoReseauxPersonnalise.dateFin"/>
      </div>
    </div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-reseaux-personnalise-complet-diapo
        :bg="bg"
        :detailReseauxPerso="infoReseauxPersonnalise"
        v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatNum, urlPhoto } from '@/services/opportunite/formatTab';
import exportExcel from '../../exportExcel';
import detailReseauxPersonnaliseCompletDiapo from './detailReseauxPersonnaliseCompletDiapo';


export default {
  name: 'infoReseauxPersonnalise',
  props: ['infoReseauxPersonnalise'],
  components: {
    appExportExcel: exportExcel,
    appDetailReseauxPersonnaliseCompletDiapo: detailReseauxPersonnaliseCompletDiapo,
  },
  data() {
    return {
      show: false,
      bg: false,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.infoReseauxPersonnalise.urlPhoto);
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let tarifImpression = 0;
      let tarifHT = 0;
      if (this.infoReseauxPersonnalise.tarifDePose) {
        tarifDePose = this.infoReseauxPersonnalise.tarifDePose;
      }
      if (this.infoReseauxPersonnalise.taxeMunicipale) {
        taxeMunicipale = this.infoReseauxPersonnalise.taxeMunicipale;
      }
      if (this.infoReseauxPersonnalise.tarifImpression) {
        tarifImpression = this.infoReseauxPersonnalise.tarifImpression;
      }
      if (this.infoReseauxPersonnalise.tarifHT) {
        tarifHT = this.infoReseauxPersonnalise.tarifHT;
      }
      if (this.infoReseauxPersonnalise.tarifNet) {
        tarifNet = this.infoReseauxPersonnalise.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
      }
      return tarifHT
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.infoReseauxPersonnalise.select = !this.infoReseauxPersonnalise.select;
      if (this.infoReseauxPersonnalise.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    formatNum(data) {
      return formatNum(data);
    },
  },
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxPersonnalise/infoReseauxPersonnalise.vue